module.exports = __webpack_public_path__ + "static/media/twitter-orange.3a0e31f1.svg";